import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-scheme-excel-upload',
  templateUrl: './scheme-excel-upload.component.html',
  styleUrls: ['./scheme-excel-upload.component.scss']
})
export class SchemeExcelUploadComponent implements OnInit {

  uploadHidden = false;
  excel_data: any;
  approvedReject: any = [];

  uploadId: any = [];

  apiData: any;
  tableData = {
    headers: [],
    rows: [],
    keys: []
  }

  isExcelUpload: boolean = false;

  id: any;
  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private apiconfig: ApiConfiguration,
    private exportExcelService: ExportExcelService,
    private activatedRoute: ActivatedRoute,
    private xlsx: XlsxService,
    private toast: ToastClientService,
    private router: Router,

  ) {
    this.uploadId = this.activatedRoute.snapshot.paramMap.get("step_id")
    this.id = this.activatedRoute.snapshot.paramMap.get("id")

  }

  ngOnInit() {

  }




  openUploadmodel(modal) {
    this.modalService.open(modal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  uploadXlsx(eve, modal) {
    // debugger
    this.xlsx.uploadXlsx(eve).then((res: any) => {
      console.log(res)
      if (this.uploadId == 2) {
        let data = res.data.filter(e => e['Outlet Code'])
        this.whitelistUpload(data)
      }
      else if (this.uploadId == 3) {
        this.colifireWhitelisting(res.data);
      }
    })
  }




  whitelistUpload(res) {
    let payload = {
      scheme_id: this.id,
      users: res
    }
    this.tableData.headers = [];
    this.tableData.rows = [];
    this.tableData.keys = [];
    console.log(payload)


    this.apiService.post(this.apiconfig.whitelistScheme, payload).subscribe((res: any) => {
      console.log(res)
      try {
        if (res.body.data.total_assigned_users != 0) {
          this.toast.Success("Excel uploaded successfully.")
          console.log("qwertyuiopasdfghjkls", res.body.data)
          this.apiData = res.body.data;
          this.uploadHidden = true;
          this.isExcelUpload = true

          let scheme_config = {
            create: true,
            whitelist: true,
            colifire_whitelist: false,
            scheme_id: this.id
          }
          localStorage.setItem('scheme_config', JSON.stringify(scheme_config))
        }
        this.uploadHidden = true;
        this.apiData = res.body.data;
        this.tableData.headers = ["Outlet Code", "Reason"]
        this.tableData.rows = res.body.data.fail;
        for (const [key, value] of Object.entries(this.tableData.rows[0])) {
          console.log(key, value);
          this.tableData.keys.push(key)
        }
        console.log(this.tableData)
      }
      catch {

      }
    }, err => {
      console.log(err)
    })
  }

  colifireWhitelisting(res) {
    let payload = {
      scheme_id: this.id,
      users: res
    }
    this.tableData.headers = [];
    this.tableData.rows = [];
    this.tableData.keys = [];
    this.apiService.post(this.apiconfig.qualifierExcelUpload, payload).subscribe((res: any) => {
      console.log(res)
      try {
        if (res.body.data.total_assigned_users != 0) {
          this.toast.Success("Excel uploaded successfully.")
          console.log("qwertyuiopasdfghjkls", res.body.data)
          this.apiData = res.body.data;
          this.uploadHidden = true;
          this.isExcelUpload = true
        }
        this.uploadHidden = true;
        this.apiData = res.body.data;
        this.tableData.headers = ["Outlet Code", "Reason"]
        this.tableData.rows = res.body.data.fail;
        for (const [key, value] of Object.entries(this.tableData.rows[0])) {
          console.log(key, value);
          this.tableData.keys.push(key)
        }
        console.log(this.tableData)
      }
      catch {

      }
    }, err => {
      console.log(err)
    })
  }




  downloadExcel() {
    let sheetName = "Individual";
    let filename = "Scheme_Whitelist_Users";
    let excelData = [{ Outlet_Code: "12345", mobile_no: '' }]
    let excelArray = [
      {
        header: "Outlet Code",
        key: "Outlet_Code"
      },
      {
        header: "mobile no",
        key: "mobile_no"
      }
    ]
    if(this.uploadId == 3){
      sheetName = "Individual";
      filename = "Qualifier_Whitelist_Users";
      excelData = [{ Outlet_Code: "12345", mobile_no: ''}]
      excelArray = [
        {
          header: "Outlet Code",
          key: "Outlet_Code"
        },
        {
          header: "mobile no",
          key: "mobile_no"
        },
        {
          header:"points",
          key:"points"
        },
        {
          header:"description",
          key:"description"
        }
      ]
  
    }
    this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);

  }

  RejectedOutletExcel() {
    // common function to print rejected recoeds
    this.xlsx.export(this.tableData.rows, "rejected_list")
  }
  // ngOnDestroy() {
  //   if (this.uploadId == 2 && this.isExcelUpload == false) {
  //     localStorage.setItem("whiteListFlag", "true");
  //     localStorage.setItem("pointConfigrationFlag", "false");
  //     localStorage.setItem("targetFlag", "false");
  //     localStorage.setItem("specialOccasionFlag", "false");
  //   }
  //   else if (this.uploadId == 3 && this.isExcelUpload == false) {
  //     localStorage.setItem("whiteListFlag", "true");
  //     localStorage.setItem("pointConfigrationFlag", "true");
  //     localStorage.setItem("targetFlag", "false");
  //     localStorage.setItem("specialOccasionFlag", "false");
  //   }
  //   else if (this.uploadId == 4 && this.isExcelUpload == false) {
  //     localStorage.setItem("whiteListFlag", "true");
  //     localStorage.setItem("pointConfigrationFlag", "true");
  //     localStorage.setItem("targetFlag", "true");
  //     localStorage.setItem("specialOccasionFlag", "false");
  //   }
  //   else if (this.uploadId == 5 && this.isExcelUpload == false) {
  //     localStorage.setItem("whiteListFlag", "true");
  //     localStorage.setItem("pointConfigrationFlag", "true");
  //     localStorage.setItem("targetFlag", "true");
  //     localStorage.setItem("specialOccasionFlag", "true");
  //   }
  // }




}

/**
 * @author Govadhan
 * @description In carton insert special occession when we upload excel for the first time, we send flag 0
 * In excel if difference between starte date and end date is 10 days,s then we show the list. If it is approved then => 1
 *  If reject => 2
 */

